import './index.css'
import React from 'react';
import Autocomplete from '../common/Autocomplete';


export default function Assignation(props: any) {
  const action = props.action
  const handleSelection = props.handleSelection
  const ticketForm = props.ticketForm
  const companiesList = props.companiesList
  const areasList = props.areasList
  const personsList = props.personsList

  return (
    <React.Fragment>

      <div className='tkt-form-section'>
        <div className='tkt-form-section-title'>
          <p>Asignación</p>
        </div>

        <div className='tkt-form-section-item'>
          <Autocomplete
            label='Compañía'
            placeholder='Compañía'
            disabled={!(action === 'create')}
            options={companiesList}
            value={ticketForm.company}
            name='company'
            handleSelection={handleSelection}
            required
          />
        </div>

        <div className='tkt-form-section-item'>
          <Autocomplete
            label='Área'
            placeholder='Área'
            disabled={!(action === 'create')}
            options={areasList}
            name='area'
            value={ticketForm.area}
            handleSelection={handleSelection}
            required
          />
        </div>

        <div className='tkt-form-section-item'>
          <Autocomplete
            label='Técnico'
            placeholder='Técnico'
            disabled={!(action === 'create')}
            options={personsList}
            name='technician'
            value={ticketForm.technician}
            handleSelection={handleSelection}
          />
        </div>

      </div>

    </React.Fragment >
  );
}
